import {
  AdapterDateFns,
  GlobalStyles,
  LocalizationProvider,
  LuxTheme,
  NotificationProvider,
  ThemeProvider,
} from "@lux/ds";
import BaseGlobalStyles from "BaseGlobalStyles";
import { ReactFCC } from "types/react";

const BaseConfiguration: ReactFCC = ({ children }) => (
  <ThemeProvider theme={LuxTheme}>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <NotificationProvider>{children}</NotificationProvider>
    </LocalizationProvider>
    <GlobalStyles />
    <BaseGlobalStyles />
  </ThemeProvider>
);

export default BaseConfiguration;
